"use client"

import { useState } from "react"
import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import Navbar from "./components/Navbar/Navbar"
import Footer from "./components/Footer/Footer"
import Home from "./pages/Home/Home"
import About from "./pages/About/About"
import Projects from "./pages/Projects/Projects"
import Awards from "./pages/Awards/Awards"
import Snapshots from "./pages/Snapshots/Snapshots"
import FAQ from "./pages/FAQ/FAQ"
import HowToVote from "./pages/HowToVote/HowToVote"
import PollingUnits from "./pages/PollingUnits/PollingUnits"
import Contacts from "./pages/Contacts/Contacts"
import "./App.css"
import Protectroute from "./Protectroute"

function App() {
  const [language, setLanguage] = useState("en")

  const toggleLanguage = () => {
    setLanguage(language === "en" ? "ha" : "en")
  }

  return (
     <Protectroute>
    <Router>
      <div className="app">
        <Navbar language={language} toggleLanguage={toggleLanguage} />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home language={language} />} />
            <Route path="/about" element={<About language={language} />} />
            <Route path="/projects" element={<Projects language={language} />} />
            <Route path="/awards" element={<Awards language={language} />} />
            <Route path="/snapshots" element={<Snapshots language={language} />} />
            <Route path="/faq" element={<FAQ language={language} />} />
            <Route path="/how-to-vote" element={<HowToVote language={language} />} />
            <Route path="/polling-units" element={<PollingUnits language={language} />} />
            <Route path="/contacts" element={<Contacts language={language} />} />
          </Routes>
        </main>
        <Footer language={language} />
      </div>
      
    </Router>
    </Protectroute>
  )
}

export default App
